<template>
    <div class="home">
        <!-- Banner轮播图 -->
        <div class="banner">
            <el-carousel :interval="4000" type="card" height="600px">
                <el-carousel-item v-for="item in bannerItems" :key="item.id">
                    <img :src="item.image" :alt="item.title" class="banner-image">
                    <div class="banner-content">
                        <h2>{{ item.title }}</h2>
                        <p>{{ item.description }}</p>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 我们的服务 -->
        <div class="section services">
            <h2 class="section-title">我们的服务</h2>
            <div class="service-grid">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="8" v-for="service in services" :key="service.id">
                        <el-card class="service-card" :body-style="{ padding: '0px' }">
                            <div class="service-icon">
                                <el-icon :size="50"><component :is="service.icon" /></el-icon>
                            </div>
                            <div class="service-content">
                                <h3>{{ service.title }}</h3>
                                <p>{{ service.description }}</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 成功案例 -->
        <div class="section cases">
            <h2 class="section-title">成功案例</h2>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" v-for="project in projects" :key="project.id">
                    <el-card class="case-card" :body-style="{ padding: '0px' }">
                        <img :src="project.image" class="case-image">
                        <div class="case-content">
                            <h3>{{ project.title }}</h3>
                            <p>{{ project.description }}</p>
                            <el-button type="primary" size="small">查看详情</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 公司信息 -->
        <div class="section company-info">
            <h2 class="section-title">关于我们</h2>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12">
                    <div class="company-content">
                        <h3>专业的软件开发团队</h3>
                        <p>我们是一家专注于提供高质量软件解决方案的技术公司。拥有多年行业经验，致力于为客户提供最优质的服务。</p>
                        <ul class="company-features">
                            <li><el-icon><Check /></el-icon> 10年+行业经验</li>
                            <li><el-icon><Check /></el-icon> 100+成功案例</li>
                            <li><el-icon><Check /></el-icon> 专业技术团队</li>
                            <li><el-icon><Check /></el-icon> 7*24小时服务</li>
                        </ul>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12">
                    <div class="contact-form">
                        <h3>联系我们</h3>
                        <el-form>
                            <el-form-item>
                                <el-input placeholder="您的姓名"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="联系电话"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="textarea" placeholder="请描述您的需求"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="submit-btn">提交需求</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import banner1 from '@/assets/images/banner1.png';
import banner2 from '@/assets/images/banner2.png';
import case1 from '@/assets/images/case1.jpg';
import case3 from '@/assets/images/case3.jpg';
export default {
    name: 'Home',
    data() {
        return {
            bannerItems: [
                {
                    id: 1,
                    title: '专业的软件开发服务',
                    description: '为企业提供一站式软件解决方案',
                    image: banner1
                },
                {
                    id: 2,
                    title: '移动应用开发',
                    description: 'iOS与Android双平台开发，一次开发多端使用',
                    image: banner2
                },
                {
                    id: 3,
                    title: '企业级解决方案',
                    description: '为企业量身定制专业的软件服务',
                    image: banner1
                }
            ],
            services: [
                {
                    id: 1,
                    icon: 'ChatDotRound',
                    title: '小程序开发',
                    description: '微信、支付宝、抖音等多平台小程序开发，助力企业快速布局移动端市场'
                },
                {
                    id: 2,
                    icon: 'Monitor',
                    title: '网站开发',
                    description: '响应式网站开发，企业官网、电商网站、管理系统等各类型网站定制'
                },
                {
                    id: 3,
                    icon: 'Cellphone',
                    title: 'APP开发',
                    description: 'iOS与Android原生应用开发，跨平台应用开发，提供完整的移动应用解决方案'
                }
            ],
            projects: [
                {
                    id: 1,
                    title: '某电商小程序',
                    description: '基于微信小程序平台开发的综合电商平台，支持多商户入驻',
                    image: case1
                },
                {
                    id: 2,
                    title: '企业管理系统',
                    description: '为大型企业定制的人力资源管理系统，提高企业管理效率',
                    image: case3
                },
                {
                    id: 3,
                    title: '生鲜配送APP',
                    description: '面向社区的生鲜配送应用，支持iOS和Android双平台',
                    image: case1
                }
            ]
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
    padding: 0;
    margin-top: 80px;
}

.section {
    padding: 60px 20px;
}

.section-title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 32px;
    color: #2c3e50;
}

/* Banner样式 */
.banner {
    margin-bottom: 40px;
}

.banner .el-carousel__item {
    display: flex;
    justify-content: center;
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.banner-content {
    position: absolute;
    bottom: 20px;
    left: 20px;
    color: white;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

/* 服务卡片样式 */
.service-card {
    height: 300px;
    margin-bottom: 20px;
    text-align: center;
    transition: all 0.3s ease;
}

.service-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.service-icon {
    padding: 30px 0;
    color: #409EFF;
}

.service-content {
    padding: 20px;
}

.service-content h3 {
    font-size: 20px;
    color: #2c3e50;
    margin-bottom: 15px;
}

.service-content p {
    color: #666;
    line-height: 1.6;
}

/* 案例卡片样式 */
.case-card {
    margin-bottom: 20px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.case-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.case-image {
    width: 100%;
    height: 500px;
    object-fit: cover;
}

.case-content {
    padding: 20px;
}

.case-content h3 {
    font-size: 20px;
    color: #2c3e50;
    margin-bottom: 10px;
}

.case-content p {
    color: #666;
    line-height: 1.6;
    margin-bottom: 15px;
}

/* 公司信息样式 */
.company-info {
    background-color: #f9fafc;
}

.company-content {
    padding: 20px;
}

.company-content h3 {
    font-size: 24px;
    color: #2c3e50;
    margin-bottom: 20px;
}

.company-content p {
    color: #666;
    line-height: 1.8;
    margin-bottom: 30px;
}

.company-features {
    list-style: none;
    padding: 0;
    margin: 20px 0;
}

.company-features li {
    margin: 15px 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #2c3e50;
}

.company-features .el-icon {
    margin-right: 10px;
    color: #67C23A;
    font-size: 18px;
}

.contact-form {
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.contact-form h3 {
    font-size: 24px;
    color: #2c3e50;
    margin-bottom: 20px;
    text-align: center;
}

.submit-btn {
    width: 100%;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .service-card {
        height: auto;
        min-height: 250px;
        margin-bottom: 15px;
    }

    .service-icon {
        padding: 20px 0;
    }

    .service-content {
        padding: 15px;
    }

    .service-content h3 {
        font-size: 18px;
        margin-bottom: 10px;
    }

    .service-content p {
        font-size: 14px;
        line-height: 1.5;
    }

    .case-card {
        margin-bottom: 15px;
    }

    .case-image {
        height: 300px;
    }

    .case-content {
        padding: 15px;
    }

    .case-content h3 {
        font-size: 18px;
        margin-bottom: 8px;
    }

    .case-content p {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 12px;
    }

    .case-content .el-button {
        width: 100%;
    }

    .company-content {
        padding: 15px;
        margin-bottom: 20px;
    }

    .company-content h3 {
        font-size: 20px;
        margin-bottom: 15px;
    }

    .company-content p {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 20px;
    }

    .company-features li {
        margin: 12px 0;
        font-size: 14px;
    }

    .company-features .el-icon {
        font-size: 16px;
    }

    .contact-form {
        padding: 15px;
    }

    .contact-form h3 {
        font-size: 20px;
        margin-bottom: 15px;
    }

    .el-form-item {
        margin-bottom: 15px;
    }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
    .service-card {
        min-height: 200px;
        margin-bottom: 10px;
    }

    .service-icon {
        padding: 15px 0;
    }

    .service-content {
        padding: 12px;
    }

    .service-content h3 {
        font-size: 16px;
        margin-bottom: 8px;
    }

    .service-content p {
        font-size: 13px;
        line-height: 1.4;
    }

    .case-card {
        margin-bottom: 10px;
    }

    .case-image {
        height: 200px;
    }

    .case-content {
        padding: 12px;
    }

    .case-content h3 {
        font-size: 16px;
        margin-bottom: 6px;
    }

    .case-content p {
        font-size: 13px;
        line-height: 1.4;
        margin-bottom: 10px;
    }

    .company-content {
        padding: 12px;
        margin-bottom: 15px;
    }

    .company-content h3 {
        font-size: 18px;
        margin-bottom: 12px;
    }

    .company-content p {
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 15px;
    }

    .company-features li {
        margin: 10px 0;
        font-size: 13px;
    }

    .company-features .el-icon {
        font-size: 14px;
    }

    .contact-form {
        padding: 12px;
    }

    .contact-form h3 {
        font-size: 18px;
        margin-bottom: 12px;
    }

    .el-form-item {
        margin-bottom: 12px;
    }
}

/*修改banner图片宽度*/
.el-carousel__item--card {width: 90%;margin-left: -20%;}


</style>
